"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TYPE_STRING;
(function (TYPE_STRING) {
    TYPE_STRING["UNDEFINED"] = "undefined";
})(TYPE_STRING || (TYPE_STRING = {}));
var CONSOLE_METHODS;
(function (CONSOLE_METHODS) {
    CONSOLE_METHODS["DEBUG"] = "debug";
    CONSOLE_METHODS["ERROR"] = "error";
    CONSOLE_METHODS["INFO"] = "info";
    CONSOLE_METHODS["LOG"] = "log";
    CONSOLE_METHODS["WARN"] = "warn";
    CONSOLE_METHODS["DIR"] = "dir";
    CONSOLE_METHODS["DIRXML"] = "dirxml";
    CONSOLE_METHODS["TABLE"] = "table";
    CONSOLE_METHODS["TRACE"] = "trace";
    CONSOLE_METHODS["GROUP"] = "group";
    CONSOLE_METHODS["GROUPCOLLAPSED"] = "groupCollapsed";
    CONSOLE_METHODS["GROUPEND"] = "groupEnd";
    CONSOLE_METHODS["CLEAR"] = "clear";
    CONSOLE_METHODS["COUNT"] = "count";
    CONSOLE_METHODS["COUNTRESET"] = "countReset";
    CONSOLE_METHODS["ASSERT"] = "assert";
    CONSOLE_METHODS["PROFILE"] = "profile";
    CONSOLE_METHODS["PROFILEEND"] = "profileEnd";
    CONSOLE_METHODS["TIME"] = "time";
    CONSOLE_METHODS["TIMELOG"] = "timeLog";
    CONSOLE_METHODS["TIMEEND"] = "timeEnd";
    CONSOLE_METHODS["TIMESTAMP"] = "timeStamp";
    CONSOLE_METHODS["CONTEXT"] = "context";
    CONSOLE_METHODS["MEMORY"] = "memory";
    CONSOLE_METHODS["TIPS"] = "tips";
})(CONSOLE_METHODS || (CONSOLE_METHODS = {}));
var Log = (function () {
    function Log(keyword, methods) {
        this.keyword = 'APP';
        this.defaultMethods = [
            CONSOLE_METHODS.LOG,
            CONSOLE_METHODS.ERROR,
            CONSOLE_METHODS.WARN
        ];
        this.disabled = true;
        this.methods = [];
        this.keyword = keyword;
        this.methods = methods;
        this.initConsole();
    }
    Log.prototype.initConsole = function () {
        var _this = this;
        var hasConsole = typeof console === TYPE_STRING.UNDEFINED;
        this.disabled = hasConsole;
        this.methods.forEach(function (name) {
            if (_this.defaultMethods.indexOf(name) > -1)
                return;
            _this[name] = _this.wrap(name);
        });
    };
    Log.prototype.wrap = function (name) {
        var _this = this;
        return function (content) {
            _this.callConsole(name, content);
        };
    };
    Log.prototype.getKeyWordStyle = function (name) {
        return "[ " + this.keyword + " " + name + " ]: ";
    };
    Log.prototype.callConsole = function (name, content, tips) {
        var logData = { content: content, keyword: this.keyword };
        if (this.disabled) {
            logData.content = void 0;
            if (tips) {
                logData.tips = void 0;
            }
            return logData;
        }
        var Console = console;
        var keyword = this.getKeyWordStyle(name);
        Console[name] && Console[name](keyword, content);
        if (tips) {
            logData.tips = tips;
            Console.info(this.getKeyWordStyle(CONSOLE_METHODS.TIPS), tips);
        }
        return logData;
    };
    Log.prototype.log = function (content) {
        return this.callConsole(CONSOLE_METHODS.LOG, content);
    };
    Log.prototype.warn = function (content, tips) {
        return this.callConsole(CONSOLE_METHODS.WARN, content, tips);
    };
    Log.prototype.error = function (content, tips) {
        return this.callConsole(CONSOLE_METHODS.ERROR, content, tips);
    };
    Log.prototype.info = function (content) {
        return this.callConsole(CONSOLE_METHODS.INFO, content);
    };
    Log.prototype.close = function () {
        this.disabled = true;
    };
    Log.prototype.open = function () {
        this.initConsole();
    };
    return Log;
}());
exports.log = new Log('Formily', []);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/shared/lib/log.js
// module id = 4505
// module chunks = 0